import React, { useEffect, useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import './dialog-dropin.css';
import DropinAdyen from '../../dropin-adyen';
import {
    somaValorTotalParcelas,
    makeParcelasStringPontoVirgula
} from '../../../modulos/mensalidade/utilsBoletoAdyen';
import moment from 'moment';
import mensalidadeService from '../../../services/mensalidades/mensalidadeService';
import { Messages } from 'primereact/messages';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function DialogDropinAdyen({
    open,
    setOpen,
    header,
    setMetodoPagamento,
    inscricao,
    faturas,
    setPagamentoSuccess,
    subGrupo
}) {
    const [loading, setLoading] = useState(true);
    const [valor, setValor] = useState(0);
    const [valorFormatAdyen, setValorFormatAdyen] = useState(0);
    const messages = useRef(null);

    useEffect(() => {
        (async () => {
            setLoading(true);

            const valorTotalParcelas = somaValorTotalParcelas(faturas);
            const valorNoFormatoAdyen = valorTotalParcelas
                .toString()
                .replace('.', '');

            setValor(valorTotalParcelas);
            setValorFormatAdyen(valorNoFormatoAdyen);
            setLoading(false);
        })();
    }, [open, faturas]);

    const showError = () => {
        messages.current.show({
            severity: 'error',
            summary: 'Pagamento não realizado',
            detail: 'Houve um problema ao processar o pagamento',
            life: 10000
        });
    };

    const onSubmit = async state => {
        try {
            setLoading(true);

            const dadosPagamento = {
                paymentData: { ...state.data },
                value: valorFormatAdyen,
                reference: makeParcelasStringPontoVirgula(faturas),
                inscricao,
                deliveryDate: moment().add(3, 'd').format('YYYY-MM-DD[T]hh:mm:ss')
            };

            const pagamento = await mensalidadeService.pagamentoParcelasCartao(
                dadosPagamento
            );

            if (pagamento.resultCode.toLowerCase() === 'refused') {
                throw pagamento;
            } else {
                setPagamentoSuccess(true);
                setOpen(false);
            }
        } catch (err) {
            setLoading(false);
            showError();
        }
    };

    const close = () => {
        setMetodoPagamento(null);
        setValor(0);
        setValorFormatAdyen(0);
        setOpen(false);
    };

    return (
        <Dialog
            visible={open}
            style={{ 
                width: '70vw', 
                marginTop: '40px' 
            }}
            onHide={close}
            position={'top'}
            header={header}
        >
            <>
                {!loading ? (
                    <>
                        <Messages ref={messages} style={{ margin: '0 15px' }} />
                        <DropinAdyen
                            valor={valorFormatAdyen}
                            onSubmit={onSubmit}
                            valorTotal={valor}
                            subGrupo={subGrupo}
                        />
                    </>
                ) : (
                    <div className="spinner-cartao">
                        <ProgressSpinner />
                    </div>
                )}
            </>
        </Dialog>
    );
}
